import useMediaView from "features/common/hooks/useMediaView";
import { DeviceType } from "models/DeviceType";
import React from "react";
import styled, { css } from "styled-components";

interface SelectButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  fill?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

const SelectButton = ({
  selected,
  fill,
  leftIcon,
  rightIcon,
  children,
  ...rest
}: SelectButtonProps) => {
  const isSmallView = useMediaView("small");
  const device = isSmallView ? "mobile" : "pc";

  return (
    <ButtonStyle
      {...rest}
      selected={selected}
      isFill={fill}
      device={device}
      type="button"
    >
      {leftIcon}
      {children}
      {rightIcon}
    </ButtonStyle>
  );
};

export default SelectButton;

/* Styles */
export const ButtonStyle = styled.button<{
  selected?: boolean;
  isFill?: boolean;
  device: DeviceType;
}>`
  width: ${({ isFill }) => (isFill ? "100%" : "")};
  height: 4.8rem;

  border: 0.1rem solid ${({ theme }) => theme.color.stroke.dark};
  border-radius: 0.5rem;

  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.2rem;

  color: ${({ theme }) => theme.color.text.secondary};

  white-space: nowrap;
  letter-spacing: -0.048rem;

  &:hover {
    border-color: ${({ theme }) => theme.color.stroke.primary};
    color: ${({ theme }) => theme.color.text.highEmphasis};
  }

  &:disabled {
    border-color: ${({ theme }) => theme.color.grey[300]};
    color: ${({ theme }) => theme.color.text.disabled};
  }

  ${({ selected, theme }) =>
    selected &&
    css`
      background: ${theme.color.background.secondary};
      border-color: ${theme.color.stroke.primary};
      color: ${({ theme }) => theme.color.text.highEmphasis};

      ${({ theme }) => theme.typography.body1.semibold}
    `}

  svg {
    flex-shrink: 0;
  }

  ${({ device }) =>
    device === "pc"
      ? css`
          padding: 1.2rem 3rem;
          ${({ theme }) => theme.typography.body1.medium}

          svg {
            width: 2rem;
            height: 2rem;
          }
        `
      : css`
          padding: 1.1rem 3rem;
          ${({ theme }) => theme.typography.body3.medium}

          svg {
            width: 1.6rem;
            height: 1.6rem;
          }
        `}
`;
